import { useState } from 'react';
import axios from 'axios';
import { Mail, Send } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success('Mensagem enviada com sucesso!');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      toast.error('Erro ao enviar mensagem. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen py-16" data-testid="contact-page">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <Mail className="text-primary" size={64} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            Entre em Contato
          </h1>
          <p className="text-lg text-muted-foreground">
            Tem alguma dúvida ou sugestão? Envie-nos uma mensagem!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-card border border-border rounded-sm p-8">
            <h2 className="text-2xl font-bold mb-6">Envie sua mensagem</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="name">Nome</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Seu nome"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  data-testid="contact-name-input"
                />
              </div>

              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  data-testid="contact-email-input"
                />
              </div>

              <div>
                <Label htmlFor="message">Mensagem</Label>
                <Textarea
                  id="message"
                  name="message"
                  placeholder="Escreva sua mensagem aqui..."
                  rows={6}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  data-testid="contact-message-input"
                />
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full"
                data-testid="contact-submit-button"
              >
                {loading ? 'Enviando...' : (
                  <>
                    <Send size={18} className="mr-2" />
                    Enviar Mensagem
                  </>
                )}
              </Button>
            </form>
          </div>

          <div className="space-y-6">
            <div className="bg-card border border-border rounded-sm p-6">
              <h3 className="text-xl font-bold mb-4">Outras formas de contato</h3>
              <div className="space-y-4 text-muted-foreground">
                <div>
                  <strong className="text-foreground">Email:</strong>
                  <br />
                  contato@bitcoinatlas.com
                </div>
                <div>
                  <strong className="text-foreground">Redes Sociais:</strong>
                  <div className="flex gap-4 mt-2">
                    <a href="#" className="hover:text-primary transition-colors">Twitter</a>
                    <a href="#" className="hover:text-primary transition-colors">Telegram</a>
                    <a href="#" className="hover:text-primary transition-colors">GitHub</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-primary/10 border-2 border-primary rounded-sm p-6">
              <h3 className="text-lg font-bold mb-3">Perguntas Frequentes</h3>
              <p className="text-sm text-muted-foreground mb-4">
                Antes de entrar em contato, confira nossa seção de tutoriais e artigos.
                Muitas dúvidas comuns já estão respondidas lá!
              </p>
              <a href="/tutoriais" className="text-primary hover:underline font-medium text-sm">
                Ver Tutoriais →
              </a>
            </div>

            <div className="bg-card border border-border rounded-sm p-6">
              <h3 className="text-lg font-bold mb-3">Tempo de Resposta</h3>
              <p className="text-sm text-muted-foreground">
                Respondemos todas as mensagens dentro de 24-48 horas em dias úteis.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;